var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5312 4.0625L14.9375 1.4375C14.6562 1.15625 14.25 1 13.875 1H7.5C6.65625 1 6 1.6875 6 2.5V15.5C6 16.3438 6.65625 17 7.5 17H16.5C17.3125 17 18 16.3438 18 15.5V5.125C18 4.75 17.8125 4.34375 17.5312 4.0625ZM16.8438 4.78125C16.9062 4.84375 16.9375 4.9375 16.9688 5H14V2.03125C14.0625 2.0625 14.1562 2.09375 14.2188 2.15625L16.8438 4.78125ZM16.5 16H7.5C7.21875 16 7 15.7812 7 15.5V2.5C7 2.25 7.21875 2 7.5 2H13V5.25C13 5.6875 13.3125 6 13.75 6H17V15.5C17 15.7812 16.75 16 16.5 16ZM15 8.375C15 8.1875 14.8125 8 14.625 8H9.375C9.15625 8 9 8.1875 9 8.375V8.625C9 8.84375 9.15625 9 9.375 9H14.625C14.8125 9 15 8.84375 15 8.625V8.375ZM15 10.375C15 10.1875 14.8125 10 14.625 10H9.375C9.15625 10 9 10.1875 9 10.375V10.625C9 10.8438 9.15625 11 9.375 11H14.625C14.8125 11 15 10.8438 15 10.625V10.375ZM15 12.375C15 12.1875 14.8125 12 14.625 12H9.375C9.15625 12 9 12.1875 9 12.375V12.625C9 12.8438 9.15625 13 9.375 13H14.625C14.8125 13 15 12.8438 15 12.625V12.375Z",
    fill: "#6C757D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.3330483e.svg";
export { ForwardRef as ReactComponent };